module.exports = __webpack_public_path__ + "fonts/karla-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Karla/karla-regular-webfont.woff2
// module id = 3428
// module chunks = 0